export default "__VITE_ASSET__ya89V30D__"